import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://demo.myssa.net/api';

const Graph5 = ({ width = 800, height = 600 }) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API}/montant_vente`);
        const data = await response.json();

        const labels = data.map(item => item.Mois);
        const montant = data.map(item => Number(item.Montant) || 0);
        const backlog = data.map(item => Number(item.Backlog) || 0);
        const montantY1 = data.map(item => Number(item["Montant Y-1"]) || 0);

        setChartData({
          labels,
          datasets: [
            {
              label: 'Montant livré',
              data: montant,
              backgroundColor: '#4caf50',
              borderColor: '#388e3c',
              borderWidth: 1,
              stack: 'stack1',
              datalabels: { display: false },
            },
            {
              label: 'Montant Backlog',
              data: backlog,
              backgroundColor: '#231d73',
              borderColor: '#4caf50',
              borderWidth: 1,
              stack: 'stack1',
              datalabels: { display: false },
            },
            {
              label: 'Montant Y-1',
              data: montantY1,
              backgroundColor: '#9e9e9e',
              borderColor: '#757575',
              borderWidth: 1,
              stack: 'stack2',
              datalabels: { display: false },
            },
          ],
        });
      } catch (error) {
        console.error('Erreur lors du chargement des données :', error);
      }
    };

    fetchData();
  }, []);

  const options = {
    responsive: false,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        color: '#000',
        anchor: 'end',
        align: 'top',
        font: { weight: 'bold' },
      },
      title: {
        display: true,
        text: 'CLIENT : Montant livré & backlog',
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
      legend: { position: 'bottom' },
    },
    scales: {
      x: {
        stacked: true,
        barPercentage: 0.9,
        categoryPercentage: 1.0,
      },
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: { display: true },
      },
    },
  };

  return (
    <div>
      {chartData ? (
        <Bar data={chartData} options={options} width={width} height={height} />
      ) : (
        <p>Chargement du graphique...</p>
      )}
    </div>
  );
};

export default Graph5;